export const ITEMS_PER_PAGE = 10;
export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export const DEFAULT_PICTURE = 'default.jpg';
export const IMAGE_PLACEHOLDER = 'https://via.placeholder.com/320x240';
export const IMAGE_PLACEHOLDER_SMALL = 'https://via.placeholder.com/50';
export const IMAGE_FILE_HINT =
  'File requirement: JPG, PNG, GIF, or WEBP up to 10 MB. Minimum pixels required: 320 for width and height.';
export const SEARCH_DEBOUNCE_MS = 600;

export const QUERY_KEYS = {
  ITEMS: 'items',
  ALL_CUSTOMIZATIONS: 'all-customizations',
  ALL_CATEGORIES: 'all-categories',
  ITEM_CUSTOMIZATIONS: 'item-customizations',
  ITEM_CATEGORIES: 'item-categories',
} as const;
